export default "__VITE_ASSET__0d99f994__"